const durations = {
  getDurationIntegerAsArray(duration) {
    const hours = Math.floor(duration / 60)
    const hoursAsMinutes = hours * 60
    const minutes = Math.round(duration - hoursAsMinutes)

    return [hours, minutes]
  },
  getDurationPadded(durationArray) {
    const [hh, mm] = durationArray
    const padHours = hh.toString().length < 2
    const padMinutes = mm.toString().length < 2

    const formatNumber = (value) => Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })

    const HH = formatNumber(padHours ? `0${hh}` : hh)
    const MM = padMinutes ? `0${mm}` : mm

    return `${HH}:${MM}`
  },
  durationFormatter(duration) {
    const durationArray = this.getDurationIntegerAsArray(duration)
    return this.getDurationPadded(durationArray)
  },
}

export default durations
